import React from 'react';
import { FaUser, FaPhoneAlt, FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa'
import shqipeZenuniImg from '../assets/images/shqipe_zenuni.jpg'
import GoogleMaps from '../components/GoogleMaps';
import ContactForm from '../components/ContactForm';

export default function Contact() {
    return (
        <div id="contact">
            <h1>Kontakt</h1>
            <div className="contact">
                <div className="round-photo">
                    <img src={shqipeZenuniImg} alt="Shqipe Zenuni" />
                </div>
                <div className="contact-info">
                    <div className="icon-text-inline">
                        <FaUser />
                        <p>Shqipe Zenuni</p>
                    </div>
                    <div className="icon-text-inline">
                        <FaPhoneAlt />
                        <a href="tel:+41786320706">+41 78 632 07 06</a>
                    </div>
                    <div className="icon-text-inline">
                        <FaMapMarkerAlt />
                        <a href="https://www.google.com/maps/place/Frohburgstrasse+5,+4600+Olten/@47.3519625,7.9014223,16z/data=!3m1!4b1!4m6!3m5!1s0x479031ca5cc6fb47:0x2e5f8c9640bb3ab3!8m2!3d47.3519589!4d7.9039972!16s%2Fg%2F11pw1xyvc7?entry=ttu&g_ep=EgoyMDI1MTAyNy4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noreferrer">
                            <address>Frohburgstrasse 5, 4600 Olten</address>
                        </a>
                    </div>
                    <div className="icon-text-inline">
                        <FaEnvelope />
                        <a href="mailto:info@dorn-craniosacral.ch">info@dorn-craniosacral.ch</a>
                    </div>
                </div>
            </div>
            <div className="form-map">
                <ContactForm />
                <GoogleMaps />
            </div>
        </div>
    );
}
